/**
 * Add the jquery.transit plugin to our jQuery instance.
 */

import jQuery from 'jquery';

window.jQuery = jQuery;

import 'jquery.transit';
